import React from 'react';
import { ResultsColumn, CheckBoxColumn, Checkbox, ResultRowOrders } from './DTCustomerSearchResult.styles';
import { maskEmailAddress } from 'util/formatUtil';

const DTCustomerSearchResult = (props) => {
  const { customer, isSelected, onCheckboxClick } = props;

  return (
    <div>
      <ResultRowOrders checked={isSelected}>
        <CheckBoxColumn>
          <Checkbox type="radio" checked={isSelected} onChange={onCheckboxClick} />
        </CheckBoxColumn>
        <ResultsColumn width="50%">
          <span>{customer.name || '-'}</span>
        </ResultsColumn>
        <ResultsColumn width="50%">
          <span>{maskEmailAddress(customer.email)}</span>
        </ResultsColumn>
      </ResultRowOrders>
    </div>
  );
};

export default React.memo(DTCustomerSearchResult);
